import ScrollMagic from 'scrollmagic';
import 'ScrollMagicAddIndicators';

export default {
	init() {

		function BecomePartnerSendMail( container ){

			function removeCallBack( message, status = 'error' ) {

				callback = container.querySelectorAll('.sendCallBack');

				if( callback.length > 0 )  {

					callback.forEach( function( box, index ){
						box.remove();
					});

				}

				container.querySelector('form .form__submit').insertAdjacentHTML('beforebegin', '<p class="sendCallBack '+status+'">'+message+'</p>' );

			}

			var fields;
			var submit = container.querySelector('.form__submit');

			var formSubmit = false;

			var emptyField;
			var requestData = [];
			var response;

			// -- Callback message -- // 

				var callback;
				var callbackSendError = container.getAttribute('data-error');
				var callbackSendSuccess = container.getAttribute('data-success');
				var callbackFieldsEmpty = container.getAttribute('data-empty');

			// -- END -- // 


			submit.addEventListener('click', function(){

				fields = container.querySelectorAll('.formField');

				if( !formSubmit && !submit.classList.contains('disable') ) {

					submit.classList.add('disable');

					// -- Check fields -- // 

						fields.forEach( function( field, index ) {

							if( field.getAttribute('type') != 'checkbox'  ) {

								if( !field.value ) {

									field.classList.add('empty');

								} else {

									field.classList.remove('empty');

								}

							} else {

								if( !field.checked ) {

									field.classList.add('empty');

								} else {

									field.classList.remove('empty');

								}

							}
							
						});

					// -- END -- //


					emptyField = container.querySelectorAll('.empty');
					if( emptyField.length == 0 ) {

						// -- Request data -- // 

							requestData.push('action=sendMailPartner');
							requestData.push('security='+container.querySelector('input#authorize').value);

							fields.forEach( function( field, index) {

								if( field.getAttribute('type') != 'checkbox' ) {

									requestData.push( field.getAttribute('name') +'='+field.value);

								}

							});						

							requestData = requestData.join('&');

						// -- END -- // 
						
						
						var request = new XMLHttpRequest();

						request.onreadystatechange = function() {

							if( request.responseText ) {

								response = JSON.parse(request.responseText);

								if( response.status == 'success' ) {

									removeCallBack(callbackSendSuccess, 'success');
									formSubmit = true;

									fields.forEach( function( field, index ) {

										if( field.getAttribute('type') != 'checkbox' ) {

											field.value = '';

										}

									});

								} else if( response.status == 'error' ) {

									removeCallBack(callbackSendError, 'error');

								}

							}

						}

						// Set up our request
						request.open('POST', document.querySelector('footer').getAttribute('data-endpoint') );

						// Add the required HTTP header for form data POST requests
						request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

						// Finally, send our data.
						request.send(requestData);

					} else {

						submit.classList.remove('disable');

						removeCallBack(callbackFieldsEmpty, 'error');

					}

				}

			});

			container.addEventListener('submit', function(e){

				e.preventDefault();

			});

		}

		function BecomePartnerInputAnimation( container ) {

			var boxes = container.querySelectorAll('.grid__field');

			boxes.forEach( function( box, index ) {

				box.querySelector('input.formField').addEventListener('focus', function() {

					box.querySelector('p').classList.add('goTop');

				});

				box.querySelector('input.formField').addEventListener('blur', function() {

					if( !box.querySelector('input.formField').value ) {

						box.querySelector('p').classList.remove('goTop');

					}

				});

			});

		}

		function BecomePartnerScrollMagic( container ) {

			var controller = new ScrollMagic.Controller();

			new ScrollMagic.Scene({triggerElement: container, triggerHook: 1 })
					// trigger animation by adding a css class
					.setClassToggle(container, "backToPosition")
					// .addIndicators({name: "- BecomePartner "}) // add indicators (requires plugin)
					.addTo(controller)
					.offset(1);

		}

		var container = document.querySelector('.becomePartnerForm');

		if( container ) {

			BecomePartnerSendMail( container.querySelector('form') );
			BecomePartnerInputAnimation( container );
			BecomePartnerScrollMagic( container );

		}

	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};
